export enum Role {
  GIVER = 'Giver',
  TAKER = 'Taker',
  GIVER_TAKER = 'Giver & Taker',
  HR_RECRUITER = 'HR or Recruiter'
}
